import React from "react";
import FontAwesome from "react-fontawesome";
import { Row, Col, Glyphicon } from "react-bootstrap";
import Api from "js/utilities/fnapi-client";
import UserHandler from "js/utilities/user-handler";

export default React.createClass({

  getInitialState() {
    return {
      downloading: false
    };
  },

  render: function() {

    var button;
    if (this.props.canDownload){
      if (this.state.downloading){
        button = <button className="btn btn-download btn-new"><FontAwesome name="circle-o-notch" className="fa-spin" /></button>
      } else {
        button = <button className="btn btn-download btn-new" onClick={this.handleDownloadLicense}>Download</button>
      }
    }
    else {
      button = <em>Locked</em>
    }

    return (
      <div key={this.props.type} className="form-row">
        <span className="form-label">
          {(this.props.type == "mobile")? "iOS/Android":((this.props.type == "web")? "Browser": this.props.type.charAt(0).toUpperCase() + this.props.type.slice(1))}
        </span>
        <span className="form-value with-right-margin nowrap">
          {this.props.expiresDate}
        </span>
        <span className="form-value">
          <span className="wrap">
          {this.props.name}
          </span>
        </span>

        <span>
          {button}
        </span>
      </div>
    );
  },

  handleDownloadLicense: function(e) {
    e.preventDefault();
    this.props.action("");

    this.setState({downloading: true});

    if(this.props.type == "mobile" || this.props.type == "web" || this.props.type == "server") {

      this.downloadLicense(this.props.id, this.props.type, function(response) {
        if(response && response.data && response.data.license && response.data.type) {
          var fileName = this.props.type;
          if(fileName == "web") {
            fileName = "FaceTec_Browser_SDK_Key"
          }
          else if(fileName == "server") {
            fileName = "FaceTec_Server_Key"
          }
          else if(fileName == "mobile") {
            fileName = "FaceTec_Mobile_SDK_Key"
          }
          var element = document.createElement('a');
          element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(response.data.license));
          element.setAttribute('download', fileName+".txt");

          element.style.display = 'none';
          document.body.appendChild(element);

          element.click();

          document.body.removeChild(element);

          this.setState({downloading: false});
        }
        else {
          this.setState({downloading: false});
          this.props.action("Please try again");
        }
      }.bind(this))
    }
    else {
      this.setState({downloading: false});
      this.props.action("Please try again");
    }
  },

  downloadLicense: function(id, type, callback) {
    Api.post("application/"+this.props.appToken+"/license/"+id+"/"+type).then(( response ) => {
      callback(response)
    }).catch( (error) => {
      callback(error)
    });
  },
});



// WEBPACK FOOTER //
// ./src/js/components/account/account-table-license-row.jsx